import { useEffect, useMemo } from 'react';
import { usePublicSettings } from '../context/PublicSettingsContext.js';
import { useStorefront } from '../context/StoreContext.js';
import { pickStoreName } from '../lib/storefront/storeName.js';

/** Title shipped in index.html — restored if the store has no business name. */
const FALLBACK_TITLE = '';

/** Puts the merchant's display name in the browser tab. */
export function useStoreTitle() {
    const { publicSettings } = usePublicSettings();
    const { organization, store } = useStorefront();

    const title = useMemo(
        () => pickStoreName({ businessName: publicSettings?.businessName, organization, store }),
        [publicSettings?.businessName, organization, store],
    );

    useEffect(() => {
        if (!title) return undefined;

        const previousTitle = document.title;
        document.title = title;

        return () => {
            document.title = previousTitle || FALLBACK_TITLE;
        };
    }, [title]);
}

export default useStoreTitle;
